// Fixed abbreviations, as on the PDF: Intl gives "Sept" for en-GB in newer ICU versions.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * "2026-09-14" → "14 Sep 2026"; em dash when missing. A calendar date is shown as it is, a
 * timestamp on this device's calendar (an invoice issued at 00:20 IST shows that day).
 */
export function formatDate(value: string | null | undefined): string {
  if (!value) return "—";
  const calendarDate = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = new Date(calendarDate ? `${value}T00:00:00Z` : value);
  if (Number.isNaN(date.getTime())) return value;
  const [year, month, day] = calendarDate
    ? [date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()]
    : [date.getFullYear(), date.getMonth(), date.getDate()];
  return `${String(day).padStart(2, "0")} ${MONTHS[month]} ${year}`;
}

/** API money strings ("1050.00") for display: "USD 1,050.00". */
export function formatMoney(amount: string, currency: string): string {
  const value = Number(amount);
  if (Number.isNaN(value)) return `${currency} ${amount}`;
  return `${currency} ${value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** Rupees with Indian digit grouping: "116900" → "INR 1,16,900.00". */
export function formatInr(amount: string): string {
  const value = Number(amount);
  if (Number.isNaN(value)) return `INR ${amount}`;
  return `INR ${value.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function capitalise(text: string): string {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}
